<app-direct-header *ngIf="!isAppLoadedForSSO"
  [hideMenu]="!topMenu"
  (menuToggle)="menuOpen = !menuOpen"
  (searchPanelToggle)="showSearchPanel = !showSearchPanel"
></app-direct-header> 
<div class="d-lg-flex">
  <ng-container *ngIf="(topMenu && !isAppLoadedForSSO)">
    <app-side-menu
      *ngIf="isDesktop; else mobileMenu"
      [items]="topMenu"
      [opened]="menuOpen"
      [topOffset]="headerHeight"
    ></app-side-menu>
    <ng-template #mobileMenu>
      <app-mobile-menu
        [bottomMenu]="bottomMenu"
        [items]="topMenu"
        [opened]="menuOpen"
        (closed)="menuOpen = false"
      ></app-mobile-menu>
    </ng-template>
  </ng-container>
  <div class="d-lg-flex flex-column flex-nowrap w-100">
    <div class="content-container" [style.paddingTop.px]="headerHeight">
      <div class="header-after-container" [style.top.px]="headerHeight">
        <app-header-search [opened]="showSearchPanel" (closed)="showSearchPanel = !showSearchPanel">
        </app-header-search>
        <header-alert></header-alert>
      </div>
      <div class="content">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="px-lg-10 px-md-10 pt-10">
      <app-footer
        *ngIf="(menu && !isAppLoadedForSSO)"
        class="amadeus-direct-style px-lg-10 px-md-10"
        [contact]="(contact$ | async)?.config"
        [socials]="(socials$ | async)?.config"
        [menu]="menu"
      ></app-footer>
    </div>
  </div>
</div>
<app-direct-timeout-banner *ngIf="!isAppLoadedForSSO"></app-direct-timeout-banner>
